import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import styles from '../../../../AlertListLayout/AlertCardView/AlertCardView.module.css';

function AlertLastReadingSuspended(props) {
  const { suspensionTypeString } = props;
  return (
    <div className="col p-0">
      <div className={`${styles['gtmd-alert-summary-infobox']} ${styles['infobox-status-suspended']}`}>
        <div className={styles['infobox-label']}>Last Reading</div>
        <div className={styles['infobox-value']}>
          <Icon icon="triangle-exclamation" />
        </div>
        <div className={styles['infobox-time']}>
          <span>
            {suspensionTypeString}
            {' '}
            Suspended
          </span>
        </div>
      </div>
    </div>
  );
}

AlertLastReadingSuspended.defaultProps = {
  suspensionTypeString: 'Device',
};

AlertLastReadingSuspended.propTypes = {
  suspensionTypeString: PropTypes.string,
};

export default AlertLastReadingSuspended;
